<template>
	<main class="">
		<div class="grid grid-cols-1 h-full">
			<section class="col-span-1 flex justify-center items-center">
				<h2 class="resource-error-message">The requested resource could not be found.</h2>
			</section>
		</div>
	</main>
</template>

<script>
export default {
	name: 'Not Found'
}
</script>

<style scoped lang="postcss">
	.resource-error-message {
		color: theme('colors.cyan');
		font-size: 1.75rem;
		font-family: theme('fontFamily.arial-bold');
	}
</style>